import 'ol/ol.css';
import {fromLonLat} from 'ol/proj';
import {Map, View} from 'ol';
import {Vector as VectorLayer, Tile as TileLayer} from 'ol/layer';
//import {Vector as VectorSource} from 'ol/source';
import {Cluster,Vector as VectorSource} from 'ol/source';
//import {Vector as VectorLayer, Tile as TileLayer} from 'ol/layer/Tile';
import XYZSource from 'ol/source/XYZ';
import TileWMS from 'ol/source/TileWMS';

import {Icon, Style} from 'ol/style.js';

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';


//vector of ships start
const source = new VectorSource();

const client = new XMLHttpRequest();

if (screen.width <= 800) {
client.open('GET', 'xml/26_06_26odd2.csv');
} else {
client.open('GET', 'xml/26_06_26odd.csv');
}


client.onload = function() {
  const csv = client.responseText;
  const features = [];

  let prevIndex = csv.indexOf('\n') + 1; // scan past the header line

  let curIndex;
  while ((curIndex = csv.indexOf('\n', prevIndex)) != -1) {
    const line = csv.substr(prevIndex, curIndex - prevIndex).split(',');
    prevIndex = curIndex + 1;

    const coords = fromLonLat([parseFloat(line[1]), parseFloat(line[0])]);
    if (isNaN(coords[0]) || isNaN(coords[1])) {
      // guard against bad data
      continue;
    }

    features.push(new Feature({
      length: parseFloat(line[5]) || 0,
      type: parseInt(line[2]) || 0,
      heading: parseInt(line[3]) || 0,
      speed: parseInt(line[4]) || 0,
      geometry: new Point(coords),
      anchor: [ 0, 0 ]
    }));
  }
  source.addFeatures(features);
};
client.send();




/////extra maps
const opensea = new XYZSource({
  url: 'https://t1.openseamap.org/seamark/{z}/{x}/{y}.png'
});

// GMTDS global AIS density (MarineTraffic 2017 tiles are offline),
// recolored to the old MT jet palette.
// Attribution: Global Maritime Traffic Density Service, GlobalMaritimeTraffic.org / MapLarge, CC BY 4.0
var gmtdsRamp = [ // high density -> low
  [79, 1, 26], [116, 0, 36], [153, 0, 38], [186, 0, 36],
  [219, 33, 39], [251, 68, 43], [251, 94, 43], [249, 119, 53],
  [245, 146, 90], [245, 174, 113], [252, 205, 116], [254, 229, 133],
  [254, 250, 157], [223, 232, 162], [180, 199, 162], [198, 218, 181]
];
var mtRamp = [ // low density -> high, from density_tiles2017
  [0, 0, 200], [0, 19, 185], [0, 39, 170], [0, 58, 154], [0, 78, 139],
  [0, 98, 124], [0, 117, 108], [0, 137, 93], [0, 156, 77], [0, 176, 62],
  [0, 196, 47], [0, 215, 31], [0, 235, 16], [0, 255, 0], [19, 255, 0],
  [39, 255, 0], [58, 255, 0], [78, 255, 0], [98, 255, 0], [117, 255, 0],
  [137, 255, 0], [156, 255, 0], [176, 255, 0], [196, 255, 0], [215, 255, 0],
  [235, 255, 0], [255, 255, 0], [255, 244, 0], [255, 232, 0], [255, 220, 0],
  [255, 208, 0], [255, 196, 0], [255, 184, 0], [255, 172, 0], [255, 160, 0],
  [255, 148, 0], [255, 136, 0], [255, 124, 0], [255, 112, 0], [255, 100, 0],
  [245, 93, 3], [235, 86, 6], [224, 78, 9], [214, 71, 12], [204, 64, 15],
  [193, 56, 18], [183, 49, 21], [172, 41, 24], [162, 34, 27], [152, 27, 30],
  [141, 19, 33], [131, 12, 36], [120, 4, 40]
];

function rampColor(ramp, t) {
  if (t <= 0) {
    return ramp[0];
  }
  if (t >= 1) {
    return ramp[ramp.length - 1];
  }
  var x = t * (ramp.length - 1);
  var i = Math.floor(x);
  var f = x - i;
  var a = ramp[i];
  var b = ramp[i + 1];
  return [
    a[0] + (b[0] - a[0]) * f,
    a[1] + (b[1] - a[1]) * f,
    a[2] + (b[2] - a[2]) * f
  ];
}

function gmtdsToMtDensity(r, g, b) {
  var best = 1e12;
  var t = 0;
  for (var i = 0; i < gmtdsRamp.length; i++) {
    var c = gmtdsRamp[i];
    var d = (r - c[0]) * (r - c[0]) + (g - c[1]) * (g - c[1]) + (b - c[2]) * (b - c[2]);
    if (d < best) {
      best = d;
      t = 1 - i / (gmtdsRamp.length - 1);
    }
  }
  return t;
}

function recolorDensityTile(imageTile, src) {
  var img = new Image();
  img.crossOrigin = 'anonymous';
  img.onload = function() {
    var canvas = document.createElement('canvas');
    canvas.width = img.width;
    canvas.height = img.height;
    var ctx = canvas.getContext('2d');
    ctx.drawImage(img, 0, 0);
    var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    var data = imageData.data;
    for (var i = 0; i < data.length; i += 4) {
      if (data[i + 3] < 20 || data[i] + data[i + 1] + data[i + 2] < 12) {
        data[i] = data[i + 1] = data[i + 2] = data[i + 3] = 0;
        continue;
      }
      var color = rampColor(mtRamp, gmtdsToMtDensity(data[i], data[i + 1], data[i + 2]));
      data[i] = color[0];
      data[i + 1] = color[1];
      data[i + 2] = color[2];
      data[i + 3] = 255;
    }
    ctx.putImageData(imageData, 0, 0);
    imageTile.getImage().src = canvas.toDataURL();
  };
  img.onerror = function() {
    imageTile.getImage().crossOrigin = null;
    imageTile.getImage().src = src;
  };
  img.src = src;
}

const mt = new TileWMS({
  url: 'https://gmtds.maplarge.com/ogc/ais:density/wms',
  params: {
    'LAYERS': 'ais:density',
    'TILED': true
  },
  crossOrigin: 'anonymous',
  tileLoadFunction: recolorDensityTile,
  transition: 0
});

/// Esri ocean depths
/* 
const ocean2 = new XYZSource({
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/' +
                  'Ocean/World_Ocean_Base/MapServer/tile/{z}/{y}/{x}'
            });
            
 */
            
//////iconcluster            

var styleCache = {};
const getIconStyle = function(feature) {

var cfeatures = feature.get('features');

  if(cfeatures.length > 1) {
     //cluster
    var heading =cfeatures[1].get('heading');
	var angle = (heading * Math.PI) / 180;
	var speed =cfeatures[1].get('speed');
	var type =cfeatures[1].get('type');
   // console.log(cfeatures[0].get('heading'));
 var size = feature.get('features').length;
          var cacheKey = size + '|' + type + '|' + speed + '|' + heading;
          var style = styleCache[cacheKey];
          if (!style) {
          if (speed==0){
if (type==0){// Manned vts
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else if (type==1){// Navigations Aids
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [210, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==2){// fishing?
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [150, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [60, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [0, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [90, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==8){// Tanker
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [30, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  
{
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}        
}
else //speed

{
if (type==0){// Manned vts
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else if (type==1){// Navigations Aids
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [210, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==2){// fishing?
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [150, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [60, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [0, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [90, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==8){// Tanker
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [30, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  
{
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}        

}
            styleCache[cacheKey] = style;
          }
          return style;
  } 
  else 
  if(cfeatures.length == 1){
     //no clusters
    var heading =cfeatures[0].get('heading');
	var angle = (heading * Math.PI) / 180;
	var speed =cfeatures[0].get('speed');
	var type =cfeatures[0].get('type');
    //console.log(cfeatures[0].get('type'));

if (speed==0){
if (type==0){// Manned vts
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else if  (type==1){// Navigations Aids
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [210, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
 else  if (type==2){// fishing?
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [150, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [60, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [0, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [90, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==8){// Tanker
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [30, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  
{
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 30],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}        
 return style;
}

//speed
else{
if (type==0){// Manned vts
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else if(type==1){// Navigations Aids
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [210, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==2){// fishing?
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==3){// Tug, Pilot, etc.
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [150, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==4){// High Speed Craft
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [60, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==6){// Passenger Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [0, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==7){// Cargo Vessel
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [90, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==8){// Tanker
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [30, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  if (type==9){// Yacht & Other
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [180, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}  
else  
{
var style = new Style({
          image: new Icon( {
          anchor: [0.5, 0.5],
          size: [30, 30],
          offset: [120, 0],
          anchorXUnits: 'fraction',
          anchorYUnits: 'pixels',
          scale: 0.8,
          rotation: angle,
          src: 'shipicon/sprite_medium.png'
        })})
}        
 return style;

}
}
}



var clusterSource = new Cluster({
        distance: 10,
        source: source
      });
      
     var clusters = new VectorLayer({
        source: clusterSource
        ,
		style:getIconStyle
      });      
      
var osmt = new TileLayer({
  source: mt,
  opacity: 1.0,
  visible: false
});
var fitWorldZoom = Math.max(0, Math.log(Math.max(window.innerWidth, window.innerHeight) / 256) / Math.LN2);
var zoomOutAllowance = window.innerWidth <= 800 ? 1.0 : 0.5;
      
var map = new Map({
  target: 'map-container',
  layers: [
    new TileLayer({
      source: opensea,
      opacity: 1.0
    }),
    osmt,
    clusters
  ],
  view: new View({
    center: fromLonLat([0, 30]),
    zoom: fitWorldZoom,
    minZoom: fitWorldZoom - zoomOutAllowance,
    multiWorld: true
  })
});

var mercatorWorldLimit = 20037508.342789244;
map.on('moveend', function() {
  var view = map.getView();
  var center = view.getCenter();
  var y = Math.max(-mercatorWorldLimit, Math.min(mercatorWorldLimit, center[1]));

  if (y !== center[1]) {
    view.setCenter([center[0], y]);
  }
});

map.on('pointermove', function(evt) {

       osmt.setVisible(true);
       setTimeout(function () {
        osmt.setVisible(false);
    }, 3000);
});

map.on('pointerdrag', function(evt) {
   if ( evt.dragging) {
       osmt.setVisible(true);
       setTimeout(function () {
        osmt.setVisible(false);
    }, 3000);
        
  }
});

map.on('click', function(evt) {
this.getTargetElement().style.cursor = 'crosshair';
show();
});

